import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import CustomAppBar from "../customAppBar";
import SideNavigation from "../sideNavigation";
import { useTenant } from "../../hooks/useTenant";
import { useAuth } from "../../context/AuthContext";
import { useDashContext } from "../../context/DashboardContext";
import BookAppointment from "./bookAppointment";
import ClientOverview from "./clientOverview";
import ClientAppointments from "./clientAppointments";
import ClientProfile from "./clientProfile";

const SLUG_TO_TAB = {
  overview:     "Overview",
  appointments: "Appointments",
  book:         "Book Appointment",
  profile:      "Profile",
};

const LABEL_TO_SLUG = {
  "Overview":          "overview",
  "Appointments":      "appointments",
  "Book Appointment":  "book",
  "Profile":           "profile",
};

const ClientDashboard = () => {
  const { tenant } = useTenant();
  const { user } = useAuth();
  const { clientTab, setClientTab } = useDashContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const slug = location.pathname.split("/")[2];
    if (!slug || !SLUG_TO_TAB[slug]) {
      navigate("/dashboard/overview", { replace: true });
      return;
    }
    setClientTab(SLUG_TO_TAB[slug]);
  }, [location.pathname]);

  const goTo = (label) =>
    navigate(`/dashboard/${LABEL_TO_SLUG[label] || label.toLowerCase()}`);

  const renderContent = () => {
    switch (clientTab) {
      case "Book Appointment":
        return <BookAppointment onBack={() => goTo("Overview")} />;
      case "Appointments":
        return <ClientAppointments />;
      case "Profile":
        return <ClientProfile />;
      default:
        return <ClientOverview user={user} setSelectedTab={goTo} />;
    }
  };

  return (
    <>
      <CustomAppBar tenant={tenant} showLoginButton={false} />

      <Box
        sx={{
          mt: "64px",
          display: "flex",
          flexDirection: "row",
          height: "calc(100svh - 64px)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            width: "220px",
            flexShrink: 0,
            height: "100%",
            overflowY: "auto",
          }}
        >
          <SideNavigation />
        </Box>

        <Box
          sx={{ flex: 1, minWidth: 0, backgroundColor: "background.default", overflowY: "auto" }}
        >
          {renderContent()}
        </Box>
      </Box>
    </>
  );
};

export default ClientDashboard;
